/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useStateValue } from '../ContextApi/StateProvider';
import './components.css';

const SignOut = () => {
  const [initialState, dispatch] = useStateValue();
  const [signedOut, setSignedOut] = useState(false);

  useEffect(() => {
  if (initialState.signOut) initialState.signOut();

  dispatch({ type: 'SET_AUTHENTICATED_USER', authenticatedUser: null });
  try { localStorage.removeItem('authenticatedUser'); } catch {}

  const timer = setTimeout(() => {
    window.location.replace('/sign-in'); // wait to redirect
  }, 150);

  return () => clearTimeout(timer);
}, [dispatch, initialState]);

return (
  <div className="flex items-center justify-center h-[60vh] text-lg text-zinc-500">
    Signing out...
  </div>
);

};

export default SignOut;